import IMG from "../../assets/img/Img"

export const DefDiv = ({ className = "", children }) => {
    return (
        <div className={`flex flex-col flex-1 p-5 border-2 border-[#00B8DB4D] rounded-xl shadow-md ${className}`}>
            {children}
        </div>
    )
}

export const PageTitle = ({ title, children }) => {
    return (
        <div className="flex flex-col flex-row justify-between items-center gap-3 border-b-2 border-[#00B8DB4D] pb-2.5">
            <div className="flex items-center gap-3">
                <span style={{ backgroundImage: `url(${IMG.FISH_ICON})` }} className="w-10 h-10 bg-[#0092B8] rounded-lg shadow-[0_0_20px_rgba(6,182,212,0.5)] bg-no-repeat bg-center" />
                <p className="text-2xl font-bold text-[#00D3F3]">{title}</p>
            </div>
            {children}
        </div>
    )
}

export const ButtonWrap = ({ className = "", children }) => {
    return (
        <div className={`flex justify-end items-center gap-2 ${className}`}>
            {children}
        </div>
    )
}

export const SectionBox = ({ className = "", variant, children }) => {
    const borderClass = variant === "danger"
        ? "border-[rgba(255,105,0,0.3)]"
        : "border-[rgba(49,65,88,0.5)]";
    return (
        <div className={`flex flex-col gap-3 p-4 border-2 ${borderClass} rounded ${className}`}>
            {children}
        </div>
    );
};

export const SectionTitle = ({ children, color, size, className = "" }) => {
    const colorClass = color === "danger" ? "text-[#F54900]" : "text-[#00D3F3]";
    const sizeClass = size === "lg" ? "text-lg" : "text-xl";
    return <h2 className={`${sizeClass} font-bold ${colorClass} ${className}`}>{children}</h2>;
};

export const SubTitle = ({ children }) => (
    <h3 className="font-bold text-[#00D3F3]">{children}</h3>
);

export const Label = ({ children }) => (
    <p className="mb-1 text-sm text-[#62748E]">{children}</p>
);

export const InfoText = ({ children, className = "" }) => (
    <p className={`text-sm text-[#62748E] ${className}`}>{children}</p>
);

export const FormField = ({ label, children, className = "" }) => (
    <div className={className}>
        <Label>{label}</Label>
        {children}
    </div>
);
